
export const randomArrayElement = <T>(array: T[]): T => {
  return array[Math.floor(Math.random() * array.length)]
}

export const getMaxNumbFromArray = (input: number[]): number => {
  if (toString.call(input) !== '[object Array]') {
    return 0
  }
  const maxNumb = Math.max.apply(null, input)
  if (isNaN(maxNumb)) {
    console.warn('Trying to find the max number of a list, but some of the elements are not a number.')
  }
  return maxNumb
}

export const filterArray = <T>(myArray: T[], toRemove: T[]): T[] => {
  return myArray.filter((el) => !toRemove.includes(el))
}
